<app-page-container [title]="'NOT FOUND'">
  <p content-title>
    404
  </p>
  <ng-container content-subtitle>
  </ng-container>
  <ng-container content-body>
  </ng-container>
</app-page-container>